import React from "react";
import RowDropdown from "./Row-dropdown";
import RowHover from './Row-hover-buttons';

const TableRow = ({index, tableRowData, contentColumnStyle, hide, rowWrapperStyle, activeClass, activeRow, contentsWrapperStyle, buttonsHoverWidth}) => {

    var buttons = [];
    var buttonsHover = [];
    var onClick = tableRowData.onClick;
    var active = true;
    var activated = true;
    if (tableRowData.activated !== undefined) {
        activated = tableRowData.activated
    }

    let hasHover = false;
    Object.entries(tableRowData).map(([key, value]) => {
        if(key === 'onClick'){
            hasHover = true
        }});

    return (
        <div
            className={`main-row-style row-element rowsTable ${(activeRow === index) ? activeClass : ''} ${activated ? '' : 'deactivated'}`}
            key={index} style={rowWrapperStyle}>
            <div
                className={`colsTable cl-code ${hasHover ? 'hasHover' : ''}`}
                style={contentsWrapperStyle}>
                {
                    Object.entries(tableRowData).map(([key, value], index) => {
                        if (key === "buttons") {
                            buttons = value;
                        } else if (key === "buttonsHover") {
                            buttonsHover = value;
                        } else if (key === "onClick") {
                            onClick = value;
                        } else if (key === "activated") {
                            active = value;
                        } else if (key === "rowDataHidden") {
                        } else {
                            return <div
                                className="text-truncate"
                                style={contentColumnStyle}
                                key={index}
                                onClick={(onClick && (() => onClick()))}>
                                {value}
                            </div>
                        }
                    })
                }
            </div>
            <div style={{width: buttonsHoverWidth}}>
                <RowHover
                    buttons={buttonsHover}/>
            </div>
            <RowDropdown
                buttons={buttons}
                hide={hide}
                index={index}/>
        </div>
    );
};

export default TableRow;
